import React from "react"
import { blockingFetchService } from "../../../../lib/blockingFetch"
import {
  validateAmountState,
  validateTextState,
  VALIDATION_TYPE,
  getDefaultCurrency,
  investorDataWithId,
  Currencies,
  InvestorPaymentTypes,
  InvestorPaymentType,
  saveDefaultCurrency,
  sortInvestors,
} from "../../../../lib/utils"
import apiServerApi from "../../../../redux/sagas/apiServerApi"
import FormControlInlineInput from "../../../fragments/FormControl.Inline.Input"
import FormControlInlineSelect from "../../../fragments/FormControl.Inline.Select"
import ProcessesStatus from "../../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import CustomBreadCrumb from "../../../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../../redux/items/types"
import { connect } from "react-redux"
import SimpleForm from "../../../fragments/SimpleForm"

class FormInvestorPayment extends React.Component {

  constructor(props) {

    super(props)
    const { investorPayment } = this.props,
    isNew = !investorPayment

    this.state = {

      isNew,
      running: false,
      success: false,
      error: null,

      investorId: !isNew && investorPayment.investor ? investorPayment.investor.id : '',
      currencyCode: isNew ? getDefaultCurrency() : investorPayment.currencyCode,
      amount: isNew ? '' : investorPayment.amount,
      paymentType: isNew ? InvestorPaymentType.BANK : investorPayment.paymentType,

      investorIdValidationState: VALIDATION_TYPE.NULL,
      currencyCodeValidationState: VALIDATION_TYPE.SUCCESS,
      amountValidationState: VALIDATION_TYPE.NULL,
      paymentTypeValidationState: VALIDATION_TYPE.SUCCESS,
    }
  }

  componentDidMount() {

    this.props.loadInvestors()
    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  investorIdChanged = investorId => this.setState({
    investorId,
    investorIdValidationState: validateTextState(investorId, false),
    error: null,
  })

  currencyCodeChanged = currencyCode => this.setState({
    currencyCode,
    currencyCodeValidationState: validateTextState(currencyCode, false),
    error: null,
  })

  amountChanged = amount => this.setState({
    amount,
    amountValidationState: validateAmountState(amount, false),
    error: null,
  })

  paymentTypeChanged = paymentType => this.setState({
    paymentType,
    paymentTypeValidationState: validateTextState(paymentType, false),
    error: null,
  })

  validateAllValues = () => {

    const { investorId, currencyCode, amount, paymentType } = this.state,
    investorIdValid = validateTextState(investorId, false),
    currencyCodeValid = validateTextState(currencyCode, false),
    amountValid = validateAmountState(amount, false),
    paymentTypeValid = validateTextState(paymentType, false)

    this.setState({
      investorIdValidationState: investorIdValid,
      currencyCodeValidationState: currencyCodeValid,
      amountValidationState: amountValid,
      paymentTypeValidationState: paymentTypeValid,
    })

    return investorIdValid === VALIDATION_TYPE.SUCCESS
      && currencyCodeValid === VALIDATION_TYPE.SUCCESS
      && amountValid === VALIDATION_TYPE.SUCCESS
      && paymentTypeValid === VALIDATION_TYPE.SUCCESS
  }

  saveClicked = () => {

    if(!this.validateAllValues()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, investorId, currencyCode, amount, paymentType } = this.state,

    data = { investor: { id: investorId }, currencyCode, amount, paymentType },

    { investorPayment } = this.props

    saveDefaultCurrency(currencyCode)

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.saveInvestorPayment(accessToken, data)
        : apiServerApi.updateInvestorPayment(accessToken, investorPayment.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(this.back, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  back = () => browserHistory.push('/financiers/investors/payments')

  renderForm = () => {

    const { isNew, error, success, running, investorId, currencyCode, amount, paymentType,
      investorIdValidationState, currencyCodeValidationState, amountValidationState,
      paymentTypeValidationState } = this.state,

    { investorData, investorPayment } = this.props,

    paymentName = investorPayment ? investorPayment.id : 'Payment'

    return (
      <SimpleForm
        title={ `${ isNew ? 'New' : 'Update' } ${ paymentName }` }
        onSave={ this.saveClicked }
        onCancel={ this.back }
        running={ running }>

        <FormControlInlineSelect
          controlId='investorId' validationState={ investorIdValidationState }
          label='Investor' value={ investorId }
          onChange={ this.investorIdChanged }
          options={ investorData }
          withEmptyOption={ true }
          helpText={ investorIdValidationState === VALIDATION_TYPE.ERROR ? 'Choose a value' : '' }
          disabled={ running || !isNew }
        />

        <FormControlInlineSelect
          controlId='currencyCode' validationState={ currencyCodeValidationState }
          label='Currency' value={ currencyCode }
          onChange={ this.currencyCodeChanged }
          options={ Currencies }
          withEmptyOption={ true }
          disabled={ running }
        />

        <FormControlInlineInput controlId="amount" validationState={ amountValidationState }
          label='Amount' placeholder='Enter value' value={ amount }
          onChange={ this.amountChanged }
          helpText={ amountValidationState === VALIDATION_TYPE.ERROR ? 'Invalid value' : '' }
          disabled={ running }
        />

        <FormControlInlineSelect
          controlId='paymentType' validationState={ paymentTypeValidationState }
          label='Payment Mode' value={ paymentType }
          onChange={ this.paymentTypeChanged }
          options={ InvestorPaymentTypes }
          withEmptyOption={ true }
          disabled={ running }
        />

        <ProcessesStatus error={ error } running={ running } success={ success } />

      </SimpleForm>
    )
  }

  render() {

    const { isNew } = this.state,
    breadCrumbData = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/investors', title: 'Investors' },
      { url: '/financiers/investors/payments', title: 'Payments' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ breadCrumbData } />
        { this.renderForm() }
      </div>
    )
  }
}

const mapStateToProps = state => {

  const investors = DckSelectors.selectAllItems(state, ItemTypes.Investor)
  sortInvestors(investors)
  const investorData = investorDataWithId(investors)

  return { investorData }
},

mapDispatchToProps = dispatch => ({
  loadInvestors: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Investor)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormInvestorPayment)



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/Form.js